import { Component, OnInit } from '@angular/core';
import { Country } from '../country';
import { CountryService } from '../country.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css'],
  providers: [CountryService]
})
export class CountryComponent implements OnInit {

	countries: Country[];
  loading: boolean = false;

  constructor(private countryService: CountryService, private router: Router) { }

  ngOnInit() {
        this.loading = true;
        this.countryService.getCountryList().subscribe(response=> {this.countries=response['data']; 
        this.loading = false;
        console.log(this.countries);
      });
    }

  clicked():void {
   		this.router.navigate(['dashboard/country-crud']);
  }  

  clickedId(id: any){
    	  this.router.navigate(['dashboard/country-crud/',id]);
  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/countries/country/country.component.ts